module.exports = __webpack_public_path__ + "static/img/pic-homepage-cooperation1.c48590d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic-homepage-cooperation1.png
// module id = 986
// module chunks = 0